/**
 * Phân bổ
 */
export default {
  /// Không phân bổ
  NoAllocation: 0,

  /// Phân bổ theo quý
  QuarterlyAllocation: 1,

  /// Phân bổ theo tháng
  MonthlyAllocation: 2
};
